export default __webpack_public_path__ + "static/media/close-thin.9ff89162.svg";